// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-slim-l-activity-lHv1LF {
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
}

.forget-password-Lni0qy .title-weo_Ez {
  color: #000;
  text-align: center;
  width: 100%;
  margin-bottom: 32px;
  padding: 10px;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.forget-password-Lni0qy .send-code-MhbYRo {
  border-radius: 8px;
  height: 32px;
  margin-right: -6px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
}

.forget-password-Lni0qy .submit-PzOfbX {
  margin-top: 30px;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./root/packages/login/src/components/ForgetPassword/index.module.less","webpack://./src/components/ForgetPassword/index.module.less"],"names":[],"mappings":"AAAA;ECCE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* font start */\n.font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n/* font end */\n.forget-password .title {\n  color: black;\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 32px;\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n.forget-password .send-code {\n  height: 32px;\n  padding: 4px 10px;\n  margin-right: -6px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.forget-password .submit {\n  margin-top: 30px;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n",".font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.forget-password .title {\n  color: #000;\n  text-align: center;\n  width: 100%;\n  margin-bottom: 32px;\n  padding: 10px;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.forget-password .send-code {\n  border-radius: 8px;\n  height: 32px;\n  margin-right: -6px;\n  padding: 4px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.forget-password .submit {\n  margin-top: 30px;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"font-slim-l-activity": `font-slim-l-activity-lHv1LF`,
	"fontSlimLActivity": `font-slim-l-activity-lHv1LF`,
	"forget-password": `forget-password-Lni0qy`,
	"forgetPassword": `forget-password-Lni0qy`,
	"title": `title-weo_Ez`,
	"send-code": `send-code-MhbYRo`,
	"sendCode": `send-code-MhbYRo`,
	"submit": `submit-PzOfbX`
};
export default ___CSS_LOADER_EXPORT___;
